var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import React from 'react';
import { Controller } from 'react-hook-form';
export var DateFieldControl = function (_a) {
    var name = _a.name, label = _a.label, control = _a.control, _b = _a.required, required = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c;
    return (_jsx(LocalizationProvider, { dateAdapter: AdapterDayjs, children: _jsx(Controller, { name: name, control: control, rules: { required: required }, render: function (_a) {
                var field = _a.field, error = _a.fieldState.error;
                return (_jsx(DatePicker, __assign({}, field, { label: label, format: "DD-MM-YYYY", disabled: disabled, value: field.value ? dayjs(field.value) : null, onChange: function (date) { return field.onChange(date ? date.toISOString() : null); }, minDate: dayjs(), slotProps: {
                        textField: {
                            error: !!error,
                            helperText: error ? error.message : '',
                            fullWidth: true,
                            variant: 'outlined',
                            InputLabelProps: { shrink: true },
                            size: 'small',
                            margin: 'normal',
                        },
                    } })));
            } }) }));
};
